import { EWebsocketChannels } from '@sigmasms/shared-types'

import { components } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(h, options) {
  return h(
    settingsFields({
      ...options,
      type: 'array'
    }),
    {
      props: {
        value: this.proxy,
        items: [
          {
            component: components.select,
            props: {
              items: Object.values(EWebsocketChannels).map(item => {
                return {
                  title: this.getTranslate(`${options.serviceName}.items.${options.path}.${item}`),
                  value: item
                }
              }),
              multiple: true
            }
          }
        ]
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
